import React from 'react';
import {Footer, Header, HeaderPages} from '../../components';
import { IntroPanel } from './IntroPanel';
import {CapabilitiesPanel} from "./CapabilitiesPanel";
import {ClientsPanel} from "./ClientsPanel";

export const HomePage: React.FC = () => {
    return (
        <>
            <Header currentPage={HeaderPages.Home} />
            <IntroPanel />
            <CapabilitiesPanel />
            <ClientsPanel />
            <Footer />
        </>
    );
};